// A fiók-detail SZEKCIÓ-AZONOSÍTÓI — egy helyen, mert KÉT fél használja őket, és ha elcsúsznak, a ragadós
// navigáció némán nem talál célt (nem hibázik, csak nem ugrik sehova):
//   • a szekció-komponensek (`FormSection id=…`) — a horgony,
//   • a `accounts.$id` route — a `SectionNav` elemei.
// A sorrend a lap DOM-sorrendje (user-döntés): Alapadatok · Egyéb adatok · Domainek · Szolgáltatások ·
// Számlázás · Integrációk · Kapcsolattartók · Ügyféladminisztrátorok — a régi CRM tab-sorrendje (base_data ·
// other_data · services · billing · integrations · contacts · client_admins) egy görgethető lapra kiterítve.
// ⚠️ A `portalAccess` SZEKCIÓ MEGSZŰNT (user-döntés). Volt egy önálló „Partner-portál hozzáférés" szakasz,
// de fölösleges volt: a szerep a kapcsolattartó-sidebarban állítható (ott a helye, ahol a kötést is
// kezeljük), a fiók-lapon pedig a Kapcsolattartók szekció badge-e mutatja. Ráadásul az ÜGYFÉLADMIN kötéseket
// is listázta — élesben 867 sort, amelyek közül EGYNEK SINCS portál-szerepe (mérve), vagyis tiszta zaj volt.
// A `parent` CSAK a létrehozás-oldalon létezik (a fiók szülő-ügyfele utólag nem módosítható).
export const ACCOUNT_SECTION = {
  parent: 'account-parent',
  basics: 'account-basics',
  other: 'account-other',
  domains: 'account-domains',
  services: 'account-services',
  billing: 'account-billing',
  integrations: 'account-integrations',
  contacts: 'account-contacts',
  admins: 'account-admins',
  danger: 'account-danger',
} as const;
